import { render, staticRenderFns } from "./exhibition-register-admin.vue?vue&type=template&id=7dcfa614&scoped=true&"
import script from "./exhibition-register-admin.vue?vue&type=script&lang=js&"
export * from "./exhibition-register-admin.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-register-admin.vue?vue&type=style&index=0&id=7dcfa614&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcfa614",
  null
  
)

export default component.exports